import {getSVGIcon} from "../../../utilities/globalUtilities";

/**
 * Defines the HTML for product promotional badges
 * @param {Object} product
 * @param {String} brandID
 */
const defineHTMLForProductPromotionalBadges = (product, brandID) => {
    const {badgeInfo} = product;
    let badgeHTML = "";

    if (badgeInfo && badgeInfo.promo) {
        badgeHTML =
            `<div class="promoBadgeImage pull-right product-promotional-badge ${brandID}-product-promotional-badge">
                <img src="${badgeInfo.promo.img}"
                    alt="${badgeInfo.promo.alt}"
                    title="${badgeInfo.promo.title}"
                    onerror="this.onerror=null;this.src='${badgeInfo.promo.fallbackImage}';"
                />
        ${badgeInfo.promo.discount && badgeInfo.promo.unit && badgeInfo.promo.showDiscountValue ?
        `<div class="ct-product-tile-badge-value-wrapper ct-product-tile-badge-value-wrapper--${badgeInfo.promo.type} ${brandID}-product-tile-badge-value-wrapper ${brandID}-product-tile-badge-value-wrapper--${badgeInfo.promo.type} ${badgeInfo.promo.type == "superprice" && badgeInfo.promo.showDiscountMessage ? "ct-product-tile-badge-value-wrapper--with-text " + brandID + "-product-tile-badge-value-wrapper--with-text" : ""} ${badgeInfo.promo.floatValue ? "ct-product-tile-badge-value-wrapper--float " + brandID + "-product-tile-badge-value-wrapper--float" : ""}">
            <div class="ct-product-tile-badge-addition d-none flex-column align-self-center text-center ${badgeInfo.promo.showPlusDESignOnBadge ? "d-flex" : ""}">
                <span class="ct-product-tile-badge-addition--sign ${brandID}-product-tile-badge-addition--sign">
                    ${badgeInfo.promo.plusLabel}
                </span>
                <span class="ct-product-tile-badge-addition--text ${brandID}-product-tile-badge-addition--text">
                    ${badgeInfo.promo.plusLabel}
                </span>
            </div>
            <span class="ct-product-tile-badge-value--${badgeInfo.promo.type} ${brandID}-product-tile-badge-value--${badgeInfo.promo.type}">
                ${badgeInfo.promo.discount}
            </span>
            <span class="ct-product-tile-badge-value--${badgeInfo.promo.type}-quantifier ${brandID}-product-tile-badge-value--${badgeInfo.promo.type}-quantifier ${badgeInfo.promo.type == "superprice" && badgeInfo.promo.showDiscountMessage ? "d-none" : ""}">
                ${badgeInfo.promo.unit}
            </span>
        </div>`
        : ""}
            </div>`;
    }

    return badgeHTML;
};

/**
 * Defines the HTML for product general badges
 * @param {Object} product
 */
const defineHTMLForProductGeneralBadges = product => {
    const {badgeInfo} = product;
    let badgeHTML = "";

    if (badgeInfo && badgeInfo.general && !badgeInfo.promo) {
        badgeHTML =
            `<div class="generalBadgeImage pull-right">
                <img src="${badgeInfo.general.img}"
                    alt="${badgeInfo.general.alt}"
                    title="${badgeInfo.general.title}"
                    onerror="this.onerror=null;this.src='${badgeInfo.general.fallbackImage}';"
                />
            </div>`;
    }

    return badgeHTML;
};

/**
 * Defines the HTML for product delivery badge
 * @param {Object} product
 */
const defineHTMLForProductDeliveryBadge = product => {
    const {deliveryTimeBadge} = product;
    let badgeHTML = "";

    if (deliveryTimeBadge) {
        badgeHTML =
            `<div class="ct-product-tile-badge ct-product-tile-badge--general text-center text-sm-right ct-delivery-badge">
                ${getSVGIcon("icon-truck-delivery")}
                <p class="pwc-form-label">${deliveryTimeBadge}</p>
            </div>`;
    }

    return badgeHTML;
};

export { defineHTMLForProductPromotionalBadges, defineHTMLForProductGeneralBadges, defineHTMLForProductDeliveryBadge };
